export const JWT_HEADER_KEY = "jwtauthorization";
export const JWT_COOKIE_KEY = "jwt";
export const JWT_HEADER_PREFIX = "Bearer ";
